<template>
  <div class="text-lg mt-5 text-gray-400 ml-2">更多模板制作上传中……</div>
</template>

<script>
import { onMounted, reactive } from "vue";
export default {
  setup() {
    const state = reactive({});
    onMounted(() => {});
    return { state };
  },
};
</script>

<style lang="less" scoped></style>
